import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SelfV2 } from 'src/app/core/alcmeon-context/models/self-v2.model';
import { API_URL_COMPANIES, API_URL_PREFIX } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { Task } from 'src/app/tasks/shared/models';

import { Archive, AssigneeConstraints, AssigneeList, TaskList } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class TaskActionsService {
  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  assign(taskId: number, taskState: string): Observable<Partial<TaskList>> {
    return this.http
      .post<Partial<TaskList>>(
        `${API_URL_PREFIX}/${this.alcmeonContextService.companyId}/task/${taskId}/acquire/${taskState}`,
        null
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  assignTo(userId: number, data: { tasks_ids: number[] }): Observable<{ tasks_by_id?: { [key: number]: Task } }> {
    return this.http
      .post<{ tasks_by_id?: { [key: number]: Task } }>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/users/${userId}/assigned`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getAssigneeList(constraints: AssigneeConstraints[]): Observable<AssigneeList> {
    return this.http
      .post<AssigneeList>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/tasks/users`, { constraints })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  archive(taskId: number, data: Archive): Observable<{ [id: string]: Task }> {
    return this.http
      .post<{ [id: string]: Task }>(
        `${API_URL_PREFIX}/${this.alcmeonContextService.companyId}/task/${taskId}/archive`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  wasAcquiredByMe(taskList: Partial<TaskList>, taskId: number, loggedUser: SelfV2): boolean {
    return !!(
      taskList?.tasks_by_id &&
      taskList.tasks_by_id[taskId] &&
      taskList.tasks_by_id[taskId].assigned_to?.id === loggedUser.id
    );
  }
}
